import {useField, useFormikContext} from 'formik'
import {isRegExp} from 'lodash'
import {FC, forwardRef, HTMLProps, Ref} from 'react'

import {Input} from './Input'

type TextInputProps = {
  name: string
  hasError?: boolean
  allowedPattern?: RegExp
  ref?: Ref<HTMLInputElement>
  displayedValue?: string
} & HTMLProps<HTMLInputElement>

export const TextInput: FC<TextInputProps> = forwardRef(
  ({name, hasError = false, allowedPattern = undefined, displayedValue, ...props}, ref) => {
    const {disabled} = props
    const [field] = useField<string>(name)
    const {isSubmitting} = useFormikContext()

    const isDisabled = isSubmitting || disabled

    return (
      <Input
        {...field}
        {...props}
        ref={ref}
        onChange={
          allowedPattern && isRegExp(allowedPattern)
            ? (e) => {
                if (!allowedPattern.test((e.target as HTMLInputElement).value)) return
                return field.onChange(e)
              }
            : field.onChange
        }
        value={displayedValue || field.value || ''}
        disabled={isDisabled}
        hasError={hasError}
      />
    )
  },
)
